import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const bootstrap = async () => {
      if (!getToken()) {
        setChecking(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        clearToken();
      } finally {
        setChecking(false);
      }
    };
    bootstrap();
  }, []);

  const login = async (password) => {
    const { data } = await api.post("/auth/login", { password });
    setToken(data.token);
    const me = await api.get("/auth/me");
    setUser(me.data);
  };

  const register = async (password) => {
    const { data } = await api.post("/auth/register", { password });
    setToken(data.token);
    const me = await api.get("/auth/me");
    setUser(me.data);
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
